import { useEffect } from 'react';
import { useAuthStore } from './authStore';

/**
 * Schedules a silent refresh ~60s before the access token expires.
 * Mount this hook once at the top of the app.
 */
export function useSilentRefresh(): void {
  const accessExpiresAt = useAuthStore((s) => s.accessTokenExpiresAt);
  const status = useAuthStore((s) => s.status);
  const refresh = useAuthStore((s) => s.refreshSession);

  useEffect(() => {
    if (status !== 'authenticated' || !accessExpiresAt) return;

    const expiresAt = new Date(accessExpiresAt).getTime();
    const refreshAtMs = expiresAt - Date.now() - 60_000; // 60s before expiry
    const wait = Math.max(refreshAtMs, 0);

    const timer = window.setTimeout(() => {
      void refresh();
    }, wait);

    return () => window.clearTimeout(timer);
  }, [accessExpiresAt, status, refresh]);
}
